import React, { Component } from 'react';
import instance from "./axios-instance";
import MainSettingContext from './MainSettingContext';
import Swal from 'sweetalert2'
import Systems from "./SystemFunction";
import { t } from './i18n';
class App extends Component {
    static contextType = MainSettingContext;
    constructor(props) {
        super(props)
        this.state = {
            mainsetting: [],
            rewardlist: [],
            activePage: 1,
            pagecount: 1,
            products_page_count: 1,
            isActive: false,
            formData: {},
            errors: {},
            formSubmitted: false,
            loading: false,
            stateopterror: "",
            stateregis: 1,
            showpass: true,
            lang: window.localStorage.getItem("lang"),
            bankselect: 0,
            trueaccount: true,
            username: null,
            tblbank: [],
            fname: "",
            checkboxacc: 0,
            userid: null,
            phoneNumber: "",
            userrecomend: this.props.userrecomend,
            logoimg: props.logoimg || "",
            linelink: props.linelink || "",
            balance: 0,
            mainacc: null,
        }
        this.forgetotpandregister = this.forgetotpandregister.bind(this);
    }
    get lang() {
        return this.props.language || this.context?.language || localStorage.getItem('lang') || 'th';
    }

    notify = (mode, msg) => {
        Swal.fire({
            title: mode + '!',
            text: msg,
            icon: mode,
            confirmButtonText: t(this.lang, 'ok')
        })
    }
    radiocheck(input) {
        this.setState({
            bankselect: input
        });
        if (input === 99) {
            this.setState({
                trueaccount: false
            });
        }
        else {
            this.setState({
                trueaccount: true,
                fname: ""
            });
        }
    }
    forgetotpandregister = async (type) => {
        const { phoneNumber, otpphoneforget, bankselect, otpphone, accnumbertxt } = this.state;
        var recheck = false;
        if (type === 4) {
            await instance.post("/api/v1/resetpassword", {
                username: phoneNumber,
                System: Systems,
                type: type
            }).then(async (res) => {
                recheck = res.data.message;
            });
        }
        else if (type === 5) {
            await instance.post("/api/v1/resetpassword", {
                username: phoneNumber,
                pin: otpphoneforget,
                System: Systems,
                type: type
            }).then(async (res) => {
                recheck = res.data.message;
            });
        }
        else if (type === 6) {
            await instance.post("/api/v1/resetpassword", {
                username: phoneNumber,
                System: Systems,
                type: type
            }).then(async (res) => {
                recheck = res.data.message;
            });
        }
        else if (type === 7) {
            await instance.post("/api/v1/resetpassword", {
                username: phoneNumber,
                pin: otpphone,
                System: Systems,
                type: type
            }).then(async (res) => {
                recheck = res.data.message;
            });
        }
        else if (type === 10) {
            return await instance.post("/api/v1/resetpassword", {
                accountnumber: accnumbertxt,
                bankid: bankselect,
                System: Systems,
                type: type
            }).then(async (res) => {
                return recheck = res.data.message;
            });
        }
        return recheck
    }
    nextstep = async (e, num) => {
        e.preventDefault();
        const { stateregis, password, bankselect, passwordcf, phoneNumber, checkboxacc, fname, otpphone, accnumbertxt } = this.state
        if (num === 1) {
            const check = await this.forgetotpandregister(6);
            if (phoneNumber.length === 10 && check.checked) {
                this.setState({
                    stateregis: 2
                });
            }
            else {
                if (phoneNumber.length !== 10) {
                    await this.notify("warning", t(this.lang, 'phone_invalid'));
                }
                else if (!check.checked && check.status === 201) {
                    await this.notify("warning", t(this.lang, 'phone_in_use'));
                }
                else {
                    await this.notify("warning", t(this.lang, 'rate_limited'));
                    this.setState({
                        stateopterror: t(this.lang, 'rate_limited')
                    });
                }
            }
        }
        else if (num === 2) {
            if (password !== passwordcf) {
                await this.notify("warning", t(this.lang, 'confirm_password_mismatch'));
            }
            else {
                this.setState({
                    stateregis: 3
                });
            }
        }
        else if (num === 3) {
            if (checkboxacc !== 0 && fname !== "" && accnumbertxt !== "") {
                this.setState({
                    stateregis: 3
                });
            }
            else {
                await this.notify("warning", t(this.lang, 'fill_bank_info'));
            }
        }
        else if (num === 5) {
            var check = await this.forgetotpandregister(7);
            if (otpphone !== "" && check.checked) {
                this.setState({
                    stateregis: 2
                });
            }
            else if (otpphone === "" || otpphone.length < 4) {
                await this.notify("warning", t(this.lang, 'incomplete_digits'));
                document.getElementById("otpphone").style = "border-color: #ef4444;";
                document.getElementById("checkotp").style.display = "block";
            }
            else {
                await this.notify("warning", t(this.lang, 'otp_invalid'));
                document.getElementById("otpphone").style = "border-color: #ef4444;";
                document.getElementById("checkotp").style.display = "block";
            }
        }
        else if (num === 11) {
            this.setState({
                stateregis: 1
            });
        }
        else if (num === 22) {
            this.setState({
                stateregis: 2
            });
        }
        else if (num === 25) {
            if (accnumbertxt === "" || typeof accnumbertxt === "undefined") {
                var title = 'error'
                var text = t(this.lang, 'no_account_number')
                var object = { title, text }
                this.modalerror(object);
            }
            else if (accnumbertxt.length < 10) {
                var title = 'error'
                var text = t(this.lang, 'no_bank_selected')
                var object = { title, text }
                this.modalerror(object);
            }
            else if (bankselect === 0) {
                var title = 'error'
                var text = t(this.lang, 'no_bank_selected')
                var object = { title, text }
                this.modalerror(object);
            }
            else {
                this.setState({
                    loading: true,
                });
                if (fname === '') {
                    let check = await this.forgetotpandregister(10)
                    if (check.checked) {
                        if (check.verifications.status === 0) {
                            this.setState({
                                trueaccount: false,
                            });
                        }
                        else if (check.verifications.status === 1) {
                            this.setState({
                                fname: check.verifications.name,
                            });
                            await this.validatergisterForm(e, check.verifications.name);
                        }
                    }
                    else {
                        var title = 'error'
                        var text = t(this.lang, 'invalid_account_number')
                        var object = { title, text }
                        this.modalerror(object);
                    }
                }
                else {
                    await this.validatergisterForm(e, fname)
                }
                this.setState({
                    loading: false,
                });
            }
        }
    };
    onChangex = event => {
        if (event.target !== undefined) {
            let nam;
            let val;
            if (event.target.name === "otpphone") {
                document.getElementById("otpphone").style = "";
                document.getElementById("checkotp").style.display = "none";
            }
            else if (event.target.name === "otpphoneforget") {
                document.getElementById("otpphoneforget").style = "";
                document.getElementById("checkotpforget").style.display = "none";
            }
            else if (event.target.name === "otpphoneforget") {
                document.getElementById("phoneNumber").style = "";
                document.getElementById("checkotpforgetphonenormal").style.display = "none";
            }
            if (event.target.name === undefined) {
                nam = event.name;
                val = event.value;
            } else {
                nam = event.target.name;
                val = event.target.value;
            }
            this.setState({ [nam]: val });
        }
    };
    async modalerror(object) {
        await this.notify(object.title, object.text);
    }
    validatergisterForm = async (e, fname) => {
        e.preventDefault();
        const { phoneNumber, password, passwordcf, bankselect, accnumbertxt } = this.state;
        if (accnumbertxt === "" || typeof accnumbertxt === "undefined") {
            var title = 'error'
            var text = t(this.lang, 'no_account_number')
            var object = { title, text }
            this.modalerror(object);
        }
        else if (fname === "") {
            var title = 'error'
            var text = t(this.lang, 'no_fullname')
            var object = { title, text }
            this.modalerror(object);
        }
        else if (password.length > 15) {
            var title = 'error'
            var text = t(this.lang, 'password_max_15')
            var object = { title, text }
            this.modalerror(object);
        }
        else if (password.length < 4) {
            var title = 'error'
            var text = t(this.lang, 'password_min_4')
            var object = { title, text }
            this.modalerror(object);
        }
        else if (password != passwordcf) {
            var title = 'error'
            var text = t(this.lang, 'confirm_password_mismatch')
            var object = { title, text }
            this.modalerror(object);
        }
        else {
            await instance.post("/api/v1/register", {
                User_id: phoneNumber,
                name: fname,
                password: password,
                accbank: bankselect,
                accno: accnumbertxt,
                System: Systems,
                Useradvise: this.state.userrecomend
            }).then(async (res) => {
                if (res.data.status === 200) {
                    var title = 'success'
                    var text = t(this.lang, 'register_success')
                    var object = { title, text }
                    await this.modalerror(object);
                    await instance.post("/api/v1/userlogin", {
                        userid: phoneNumber,
                        password: password,
                        System: Systems,
                        Function: 'validateLoginForm-navbar.js'
                    }).then((res) => {
                        if (res.status === 200) {
                            if (res.data.status === 200) {
                                localStorage.setItem('auth_token', res.data.token);
                                setInterval(() =>
                                    window.location.href = '/'
                                    , 1500);
                            }
                        }
                    });
                }
                else if (res.data.status === 203) {
                    var title = 'error'
                    var text = t(this.lang, 'account_already_registered')
                    var object = { title, text }
                    this.modalerror(object);
                }
                else if (res.data.status === 202) {
                    var title = 'error'
                    var text = t(this.lang, 'username_already_taken')
                    var object = { title, text }
                    this.modalerror(object);
                }
                else {
                    var title = 'error'
                    var text = t(this.lang, 'invalid_username_name')
                    var object = { title, text }
                    this.modalerror(object);
                }
            });
        }
    };
    changepass = (e) => {
        e.preventDefault();
        this.setState({
            showpass: this.state.showpass ? false : true,
        });
    }
    async saveclickaff(linkid) {
        await instance.post("/api/v1/saveclickaff", {
            linkid: linkid,
            System: Systems,
        }).then((res) => {
            if (res.data.status === 200) {
                var date = new Date()
                this.setState({
                    userrecomend: res.data.username,
                    link: linkid
                });
                var username = res.data.username
                var object = { date, username }
                localStorage.setItem('aff', JSON.stringify(object))
            }
        }).catch(async (err) => {
        });
    }
    async saveclick(linkid) {
        await instance.post("/api/v1/saveclickaff", {
            linkid: linkid,
            System: Systems,
        }).then((res) => {
            if (res.data.status === 200) {
                var date = new Date()
                var username = res.data.username
                this.setState({
                    userrecomend: username,
                });
                var object = { date, username }
                localStorage.setItem('aff', JSON.stringify(object))
            }
        }).catch(async (err) => {
        });
    }
    componentDidUpdate(prevProps, prevState) {
        const { userrecomend } = this.props;
        if (prevProps.userrecomend !== userrecomend) {
            if (userrecomend !== this.state.userrecomend) {
                this.setState({ userrecomend: userrecomend });
                const mainSettingKey = "mainSettingCache";
                const mainSettingTTL = 5 * 60 * 1000;
                var token = localStorage.getItem('auth_token');
                const mainSettingCache = this.getCache(mainSettingKey, mainSettingTTL);
                if (mainSettingCache) {
                    try {
                        const data = mainSettingCache;
                        document.title = data.tblsetting[0].title;
                        const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                        link.type = 'image/svg+xml';
                        link.rel = 'icon';
                        link.href = data.tblsetting[0].imglogo;
                        document.getElementsByTagName('head')[0].appendChild(link);
                        const linkx = document.querySelector("link[rel*='icon']") || document.createElement('link');
                        linkx.rel = 'icon';
                        linkx.type = 'image/png';
                        linkx.sizes = '32x32';
                        linkx.href = data.tblsetting[0].imglogo;
                        document.getElementsByTagName('head')[0].appendChild(linkx);
                        const cat0u = data.tblcatagoryx && data.tblcatagoryx[0];
                        this.setState({
                            webname: data.tblsetting[0].Description,
                            logoimg: data.tblsetting[0].imglogo,
                            paymentbool: data.paymentbool,
                            whellsetting: data.tblwheelsetting,
                            maxwithdrawstatus: cat0u ? cat0u.withdrawmax : 0,
                            luckywheeldisplay: data.tblwheelsetting[0].status === 1,
                            linelink: data.message && data.message[1] ? data.message[1].value : '',
                            webnamex: data.message && data.message[7] ? data.message[7].value : '',
                            mainacc: data?.tblmain,
                            tblbank: data?.tblbank,
                            describemain: data.tblsetting[0].title,
                            System: cat0u ? cat0u.System : '',
                            cashoutSet: data.tblcashoutsetting && data.tblcashoutsetting[0],
                            inviteSet: data.tblinvitedsetting && data.tblinvitedsetting[0],
                            datas: data.message,
                            limit: cat0u ? { min: cat0u.limitdeposit, max: cat0u.maxdeposit } : { min: 0, max: 0 },
                        });
                    }
                    catch (ex) { }
                }
            }
        }
        if (prevProps.linelink !== this.props.linelink && this.props.linelink) {
            this.setState({ linelink: this.props.linelink });
        }
        if (prevProps.logoimg !== this.props.logoimg && this.props.logoimg) {
            this.setState({ logoimg: this.props.logoimg });
        }
    }
    getCache = (key, ttl) => {
        const cachedData = JSON.parse(localStorage.getItem(key));
        if (cachedData && (Date.now() - cachedData.timestamp < ttl)) {
            return cachedData.data;
        }
        return null;
    };
    setCache = (key, data) => {
        localStorage.setItem(key, JSON.stringify({
            timestamp: Date.now(),
            data: data,
        }));
    };
    async componentDidMount() {
        const mainSettingKey = "mainSettingCache";
        const mainSettingTTL = 5 * 60 * 1000;
        var token = localStorage.getItem('auth_token');
        const mainSettingCache = this.getCache(mainSettingKey, mainSettingTTL);
        if (mainSettingCache) {
            try {
                const data = mainSettingCache;
                const cat0c = data.tblcatagoryx && data.tblcatagoryx[0];
                this.setState({
                    webname: data?.tblsetting[0].Description,
                    logoimg: data?.tblsetting[0].imglogo,
                    paymentbool: data.paymentbool,
                    whellsetting: data.tblwheelsetting,
                    maxwithdrawstatus: cat0c ? cat0c.withdrawmax : 0,
                    luckywheeldisplay: data.tblwheelsetting[0].status === 1,
                    linelink: data.message && data.message[1] ? data.message[1].value : '',
                    webnamex: data.message && data.message[7] ? data.message[7].value : '',
                    mainacc: data?.tblmain,
                    tblbank: data?.tblbank,
                    describemain: data?.tblsetting[0].title,
                    System: cat0c ? cat0c.System : '',
                    cashoutSet: data.tblcashoutsetting && data.tblcashoutsetting[0],
                    inviteSet: data.tblinvitedsetting && data.tblinvitedsetting[0],
                    datas: data.message,
                    limit: cat0c ? { min: cat0c.limitdeposit, max: cat0c.maxdeposit } : { min: 0, max: 0 },
                });
            }
            catch (ex) { }
        }
        else {
            const data = this.context;
            if (data) {
                const datas = data.message;
                const cat0 = data.tblcatagoryx && data.tblcatagoryx[0];
                const limit = cat0
                    ? { min: cat0.limitdeposit, max: cat0.maxdeposit }
                    : { min: 0, max: 0 };
                this.setState({
                    webname: data.tblsetting[0].Description,
                    logoimg: data.tblsetting[0].imglogo,
                    whellsetting: data.tblwheelsetting,
                    maxwithdrawstatus: cat0 ? cat0.withdrawmax : 0,
                    luckywheeldisplay: data.tblwheelsetting[0].status === 1,
                    linelink: datas && datas[1] ? datas[1].value : '',
                    webnamex: datas && datas[7] ? datas[7].value : '',
                    mainacc: data.tblmain,
                    tblbank: data?.tblbank,
                    paymentbool: data.paymentbool,
                    describemain: data.tblsetting[0].title,
                    cashoutSet: data.tblcashoutsetting && data.tblcashoutsetting[0],
                    inviteSet: data.tblinvitedsetting && data.tblinvitedsetting[0],
                    datas,
                    limit,
                });
            }
        }
    }
    render() {
        const lang = this.state.lang || this.context?.language || 'th';
        const { stateopterror, tblbank } = this.state
        return (
            <>
                <div className="-games-provider-wrapper pl-0 pr-0 mx-auto -menu-index-page-bg col-12">
                    {/**/}
                </div>
                <div className="-games-index-page col-12">
                    <div className="mb-2 text-white-v1">
                        <div className="d-none d-lg-block">
                        </div>
                        {/**/}
                        <div className="padding-router-view">
                            <div className="">
                                <div className=" m-3">
                                    <div className="container">
                                        <div className="row">
                                            <div className="pt-5 text-white-v1 text-center col col-sm-8 col-md-10 col-lg-8 col-xl-5 pl-0 pr-0 mx-auto my-auto">
                                                <br />
                                                <div className="x-modal-separator-container x-login-form  bg-signIn neon-auth-box">
                                                    <div className="-top">
                                                        <div data-animatable="fadeInModal" className="animated fadeInModal"  >
                                                            <div className="text-font-title-signin text-white-v1 mt-2 pt-2">
                                                                <img
                                                                    src={this.state.logoimg}
                                                                    className="logo-w-signIn-v113"
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <div className="-img-container text-center">
                                                            </div>
                                                            {/**/}
                                                            <form autocomplete="new-password" style={{ marginTop: "-10px" }}>
                                                                <div className="x-modal-separator-container x-login-form pb-3  bg-signup">
                                                                    <div className="-top" style={{ display: this.state.stateregis === 1 ? "" : "none" }}>
                                                                        <div className="-fake-inner-body">
                                                                            <div className="x-step-register">
                                                                                <div className="px-0 m-auto -container-wrapper">
                                                                                    <div className="-step-box-outer step-active" />
                                                                                    <div className="-step-box-outer" />
                                                                                    <div className="-step-box-outer" />
                                                                                    <div className="-step-box-outer" />
                                                                                </div>
                                                                            </div>
                                                                            <div>
                                                                                <div className="-img-container text-white text-center">
                                                                                    <h6> <span id='menu183'>{t(lang,'register_phone_subtitle')}</span> </h6>
                                                                                </div>
                                                                                <div className="-x-input-icon mb-1 text-center text-center">
                                                                                    <div className="input-group mb-2">
                                                                                        <span
                                                                                            className="input-group-text bg-border-input-icon"
                                                                                            id="basic-addon1"
                                                                                        >
                                                                                            <img className="-icon"
                                                                                                alt="EZ Slot"
                                                                                                width={15}
                                                                                                height={15}
                                                                                                src="/images/cdn/19b79505-9b5a-4589-8617-be44abfb3a00.png" />
                                                                                        </span>
                                                                                        <input
                                                                                            onChange={this.onChangex}
                                                                                            type="text"
                                                                                            id="phoneNumber"
                                                                                            name="phoneNumber"
                                                                                            className="form-control form-control-form bg-border-input"
                                                                                            maxLength={10}
                                                                                            minLength={10}
                                                                                            aria-label="phoneNumber"
                                                                                            placeholder={"xxx-xxxxxxxx"}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div style={{ display: "none" }}>
                                                                                <div className="-img-container text-white text-center">
                                                                                    <h6> <span id='menu183'>{t(lang,'referrer')}</span> </h6>
                                                                                </div>
                                                                                <div className="-x-input-icon mb-1 text-center text-center">
                                                                                    <div className="input-group mb-2">
                                                                                        <span
                                                                                            className="input-group-text bg-border-input-icon"
                                                                                            id="basic-addon1"
                                                                                        >
                                                                                            <img className="-icon"
                                                                                                alt="EZ Slot"
                                                                                                width={15}
                                                                                                height={15}
                                                                                                src="/images/cdn/c8d943f5-025b-4bee-ee2e-752b3e427d00.png" />
                                                                                        </span>
                                                                                        <input
                                                                                            type="text"
                                                                                            id="userrecomend"
                                                                                            readOnly
                                                                                            value={this.state.userrecomend}
                                                                                            className="form-control form-control-form bg-border-input"
                                                                                            maxLength={10}
                                                                                            minLength={10}
                                                                                            aria-label="userrecomend"
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="text-center">
                                                                                <div />
                                                                                <div>
                                                                                    <div className="mt-1 mb-2">
                                                                                        <div>
                                                                                            <button
                                                                                                ref={(input) => { this.nameInput = input; }}
                                                                                                onClick={(e) => {
                                                                                                    this.nextstep(e, 1)
                                                                                                }}
                                                                                                className="btn -submit js-submit-accept-term rounded-pill v-login mt-lg-1 mt-0 w-100 p-2">
                                                                                                <span><span id='menu184'>{t(lang,'next')}</span> </span>
                                                                                            </button>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="-top" style={{ display: (this.state.stateregis === 2 || this.state.stateregis === 3) ? "" : "none" }}>
                                                                        <div className="-fake-inner-body" style={{ display: this.state.stateregis === 2 ? "" : "none" }}>
                                                                            <div className="x-step-register">
                                                                                <div className="px-0 m-auto -container-wrapper">
                                                                                    <div className="-step-box-outer step-active" />
                                                                                    <div className="-step-box-outer step-active" />
                                                                                    <div className="-step-box-outer step-active" />
                                                                                    <div className="-step-box-outer" />
                                                                                </div>
                                                                            </div>
                                                                            <div>
                                                                                <div className="-img-container text-center" style={{ color: "white" }}>
                                                                                    <h6><span id='menu186'>{t(lang,'password_step')}</span> </h6>
                                                                                </div>
                                                                                <div className="mb-1 text-center">
                                                                                    <div className="-x-input-icon flex-column">
                                                                                        <div className="input-group mb-3">
                                                                                            <span className="input-group-text bg-border-input-icon">
                                                                                                <img
                                                                                                    className="-icon"
                                                                                                    alt="EZ Slot"
                                                                                                    width={15}
                                                                                                    height={15}
                                                                                                    src="/images/cdn/bb8fe716-5b2a-4b92-60ff-7608db842e00.png"
                                                                                                />
                                                                                            </span>
                                                                                            <div style={{ position: "relative", flex: 1 }}>
                                                                                                <input
                                                                                                    onChange={this.onChangex}
                                                                                                    type={!this.state.showpass ? "text" : "password"}
                                                                                                    id="password"
                                                                                                    name="password"
                                                                                                    className="form-control form-control-form"
                                                                                                    placeholder="password"
                                                                                                    style={{ paddingRight: "40px", borderRadius: "0 28px 28px 0" }}
                                                                                                />
                                                                                                <span
                                                                                                    role="button"
                                                                                                    onClick={(e) => this.changepass(e)}
                                                                                                    style={{ position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)", display: "flex", alignItems: "center", cursor: "pointer" }}
                                                                                                >
                                                                                                    <svg style={{ display: (!this.state.showpass) ? "none" : "" }} xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="#555" className="bi bi-eye-slash" viewBox="0 0 16 16">
                                                                                                        <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" />
                                                                                                        <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z" />
                                                                                                        <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z" />
                                                                                                    </svg>
                                                                                                    <svg style={{ display: (this.state.showpass) ? "none" : "" }} xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="#555" className="bi bi-eye" viewBox="0 0 16 16">
                                                                                                        <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                                                                                                        <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                                                                                                    </svg>
                                                                                                </span>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="input-group mb-3">
                                                                                            <span className="input-group-text bg-border-input-icon">
                                                                                                <img
                                                                                                    className="-icon"
                                                                                                    alt="EZ Slot"
                                                                                                    width={15}
                                                                                                    height={15}
                                                                                                    src="/images/cdn/bb8fe716-5b2a-4b92-60ff-7608db842e00.png"
                                                                                                />
                                                                                            </span>
                                                                                            <div style={{ position: "relative", flex: 1 }}>
                                                                                                <input
                                                                                                    onChange={this.onChangex}
                                                                                                    type={!this.state.showpass ? "text" : "password"}
                                                                                                    id="passwordcf"
                                                                                                    name="passwordcf"
                                                                                                    className="form-control form-control-form"
                                                                                                    placeholder="password"
                                                                                                    style={{ paddingRight: "40px", borderRadius: "0 28px 28px 0" }}
                                                                                                />
                                                                                                <span
                                                                                                    role="button"
                                                                                                    onClick={(e) => this.changepass(e)}
                                                                                                    style={{ position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)", display: "flex", alignItems: "center", cursor: "pointer" }}
                                                                                                >
                                                                                                    <svg style={{ display: (!this.state.showpass) ? "none" : "" }} xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="#555" className="bi bi-eye-slash" viewBox="0 0 16 16">
                                                                                                        <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" />
                                                                                                        <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z" />
                                                                                                        <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z" />
                                                                                                    </svg>
                                                                                                    <svg style={{ display: (this.state.showpass) ? "none" : "" }} xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="#555" className="bi bi-eye"
                                                                                                        viewBox="0 0 16 16"
                                                                                                    >
                                                                                                        <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                                                                                                        <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                                                                                                    </svg>
                                                                                                </span>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="text-center">
                                                                                    <div className="m-auto -term-and-condition-check-box">
                                                                                        <div className="x-checkbox-primary d-flex justify-content-center">
                                                                                            <a
                                                                                                onClick={(e) => {
                                                                                                    this.nextstep(e, 11)
                                                                                                }}
                                                                                                role="button" className="text-white-v1">
                                                                                                <span id='menu187'>{t(lang,'cancel')}</span>
                                                                                            </a>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div />
                                                                                    <div>
                                                                                        <div className="mt-1 mb-2">
                                                                                            <div>
                                                                                                <button
                                                                                                    onClick={(e) => {
                                                                                                        this.nextstep(e, 2)
                                                                                                    }}
                                                                                                    className="btn -submit js-submit-accept-term rounded-pill v-login mt-lg-1 mt-0 w-100 p-2">
                                                                                                    <span>    <span id='menu188'>{t(lang,'next')}</span></span>
                                                                                                </button>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="-top" style={{ display: this.state.stateregis === 3 ? "" : "none" }}>
                                                                            <div className="-fake-inner-body">
                                                                                <div className="x-step-register">
                                                                                    <div className="px-0 m-auto -container-wrapper">
                                                                                        <div className="-step-box-outer step-active" />
                                                                                        <div className="-step-box-outer step-active" />
                                                                                        <div className="-step-box-outer step-active" />
                                                                                        <div className="-step-box-outer step-active" />
                                                                                    </div>
                                                                                </div>
                                                                                <div>
                                                                                    <div className="-img-container text-center" style={{ color: "white" }}>
                                                                                        <h6><span id='menu190'>{t(lang,'select_bank_title')}</span></h6>
                                                                                    </div>
                                                                                    <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 css-15j76c0">
                                                                                        <div className="inputPaddingRegisterTop">
                                                                                            <div className="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-1 css-tuxzvu">
                                                                                                {tblbank.map((listitem, i) => (
                                                                                                    <a key={listitem.bank_id || i} className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-2 css-o0rlmm"
                                                                                                        onClick={(e) => {
                                                                                                            this.radiocheck(listitem.bank_id)
                                                                                                        }}
                                                                                                    >
                                                                                                        <img
                                                                                                            className={this.state.bankselect == listitem.bank_id ? "imgBankNotSelect" : "imgBank"}
                                                                                                            src={listitem.img_path}
                                                                                                            alt="bank list"
                                                                                                        />
                                                                                                    </a>))}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="input-group mt-2">
                                                                                        <span
                                                                                            className="input-group-text bg-border-input-icon"
                                                                                            id="basic-addon1"
                                                                                        >
                                                                                            <img
                                                                                                className="-icon"
                                                                                                alt="EZ Slot"
                                                                                                width={15}
                                                                                                height={15}
                                                                                                src="/images/cdn/bb8fe716-5b2a-4b92-60ff-7608db842e00.png"
                                                                                            />
                                                                                        </span>
                                                                                        <input
                                                                                            onChange={this.onChangex}
                                                                                            id="accnumbertxt"
                                                                                            inputMode="text"
                                                                                            name="accnumbertxt"
                                                                                            required="required"
                                                                                            className="form-control form-control-form border-r-0"
                                                                                            aria-label="member_accid"
                                                                                            placeholder={t(lang,'account_no_placeholder')}
                                                                                        />
                                                                                    </div>
                                                                                    <div className="input-group mt-2" style={{ display: this.state.trueaccount ? "none" : "" }}>
                                                                                        <span
                                                                                            className="input-group-text bg-border-input-icon"
                                                                                            id="basic-addon1"
                                                                                        >
                                                                                            <img
                                                                                                className="-icon"
                                                                                                alt="EZ Slot"
                                                                                                width={15}
                                                                                                height={15}
                                                                                                src="/images/cdn/84f8435d-3a19-4e45-eb3c-57f582263300.png"
                                                                                            />
                                                                                        </span>
                                                                                        <input
                                                                                            type="text"
                                                                                            onChange={this.onChangex}
                                                                                            id="fname"
                                                                                            value={this.state.fname}
                                                                                            name="fname"
                                                                                            required="required"
                                                                                            className="form-control form-control-form border-r-0"
                                                                                            aria-label="member_accid"
                                                                                            placeholder={t(lang,'account_name_placeholder')}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                                <div className="text-center">
                                                                                    <div className="m-auto -term-and-condition-check-box">
                                                                                        <div className="x-checkbox-primary d-flex justify-content-center">
                                                                                            <a
                                                                                                onClick={(e) => {
                                                                                                    this.nextstep(e, 11)
                                                                                                }}
                                                                                                role="button" className="text-white-v1">
                                                                                                <span id='menu191'>{t(lang,'cancel')}</span>
                                                                                            </a>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div />
                                                                                    <div>
                                                                                        <div>
                                                                                            <a
                                                                                                onClick={(e) => {
                                                                                                    this.nextstep(e, 25)
                                                                                                }}
                                                                                                disabled={this.state.loading}
                                                                                                type="submit"
                                                                                                role="button"
                                                                                                className="btn -submit js-submit-accept-term rounded-pill v-login mt-lg-1 mt-0 w-100 p-2"
                                                                                            >
                                                                                                <div style={{ display: this.state.loading ? "" : "none" }}>
                                                                                                    <span className="spinner-border" role="status">
                                                                                                        <span className="visually-hidden">Loading...</span>
                                                                                                    </span>
                                                                                                </div>
                                                                                                <div style={{ display: this.state.loading ? "none" : "" }}>
                                                                                                    <span id='menu192'>{t(lang,'confirm')}</span>
                                                                                                </div>
                                                                                            </a>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </form>
                                                            <div className="mt-3">
                                                                <div className="row m-0">
                                                                    <div className="col-6 col-md-6">
                                                                        <button className="btn -submit js-submit-accept-term rounded-pill v-login mt-lg-1 mt-0 w-100 p-2"
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                window.location.href = '/signin';
                                                                            }}
                                                                        >
                                                                            <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width={15}
                                                                                height={15}
                                                                                fill="currentColor"
                                                                                className="bi bi-person-fill"
                                                                                viewBox="0 0 16 16"
                                                                            >
                                                                                <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3Zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
                                                                            </svg>
                                                                            <span><span id='menu194'>{t(lang,'login')}</span></span>
                                                                        </button>
                                                                    </div>
                                                                    <div className="col-6 col-md-6">
                                                                        <a href={this.state.linelink} className="btn -submit js-submit-accept-term btn-success v-login-contact mt-lg-1 mt-0 w-100 p-2">
                                                                            <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width={15}
                                                                                height={15}
                                                                                fill="currentColor"
                                                                                className="bi bi-telephone-fill"
                                                                                viewBox="0 0 16 16"
                                                                            >
                                                                                <path
                                                                                    fillRule="evenodd"
                                                                                    d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"
                                                                                />
                                                                            </svg>
                                                                            <span><span id='menu195'>{t(lang,'contact')}</span></span>
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
export default App;
